import { Controller } from "@hotwired/stimulus"

// Click-to-sort for admin tables. Mark sortable <th> cells with
// data-action="click->sortable#sort" and give each a Font Awesome chevron
// flagged data-sortable-target="icon"; rows live in a tbody flagged
// data-sortable-target="body". Clicking a header sorts rows by that column's
// text; clicking the same header again reverses direction. Comparison uses
// numeric collation, so digit runs compare by value ("9" before "10") and
// plain-number columns sort correctly. Reordering preserves each row's hidden
// state, so it composes with the filter controller.
export default class extends Controller {
  static targets = ["body", "icon"]

  sort(event) {
    const header = event.currentTarget
    const index = header.cellIndex
    const ascending = header.dataset.sortDirection !== "asc"

    // Prefer an explicit data-sort-value (e.g. an ISO date) when a cell provides one,
    // so columns can sort by a hidden key rather than their displayed text.
    const cellValue = cell => (cell.dataset.sortValue ?? cell.textContent).trim().toLowerCase()

    const rows = Array.from(this.bodyTarget.rows)
    rows.sort((a, b) => {
      const aText = cellValue(a.cells[index])
      const bText = cellValue(b.cells[index])
      return ascending
        ? aText.localeCompare(bText, undefined, { numeric: true })
        : bText.localeCompare(aText, undefined, { numeric: true })
    })
    rows.forEach(row => this.bodyTarget.appendChild(row))

    this.#reset()
    header.dataset.sortDirection = ascending ? "asc" : "desc"
    const icon = header.querySelector("[data-sortable-target='icon']")
    icon.className = `fa-solid ml-1 text-gray-600 ${ascending ? "fa-chevron-up" : "fa-chevron-down"}`
  }

  #reset() {
    this.element
      .querySelectorAll("th[data-sort-direction]")
      .forEach(th => delete th.dataset.sortDirection)
    this.iconTargets.forEach(icon => {
      icon.className = "fa-solid fa-chevron-down ml-1 text-gray-300"
    })
  }
}
